module.exports = __webpack_public_path__ + "static/img/android.3daa7eff.png";